import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InventoryCategory } from '@contracts/interfaces/inventory-category';
import { InventoryCategoryService } from '../../services/inventory-category.service';

export interface DialogData {
  category: any;
}

@Component({
  selector: 'app-dialog-inventory-cat-rename',
  templateUrl: 'inventory-cat-rename.dialog.html',
  styleUrls: ['./inventory-cat-rename.dialog.scss']
})
export class InventoryCatRenameDialogComponent {

  public oldName = "";
  public indented = false;

  public category: InventoryCategory;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<InventoryCatRenameDialogComponent>,
    public inventoryCategoryService: InventoryCategoryService
    ) {
      this.oldName = this.data.category.name;
      this.category = this.data.category;
    }

  ngOnInit() {


  }

  save () {
    if (this.category.name != "" || this.oldName != this.category.name) {
      this.inventoryCategoryService.updateCategory(this.category).subscribe(r => {
        this.dialogRef.close({});
      })
    } else {
      this.dialogRef.close({

      });
    }
  }
}
